module.exports = __webpack_public_path__ + "img/img2.3d9b8c0b.png";